import React from "react";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Select from "react-select";
import Spinner from "../../components/Spinner";
import "../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

// Flattened helper arrays
const BILLING_TEMPLATE_TYPES = [
  { value: "", label: "Select" },
  { value: "SEARCH", label: "SEARCH" },
  { value: "TRACKING", label: "TRACKING" },
  { value: "MOBILE", label: "MOBILE" },
  { value: "ELECTRONICS", label: "ELECTRONICS" },
  { value: "ELECTRICAL", label: "ELECTRICAL" },
  { value: "MECHANICAL", label: "MECHANICAL" },
  { value: "FURNITURE", label: "FURNITURE" },
  { value: "VEHICLES", label: "VEHICLES" },
  { value: "ANIMALS", label: "ANIMALS" },
];

const ACTIVE_STATUS_OPTIONS = [
  { value: "", label: "Select" },
  { value: "YES", label: "Yes" },
  { value: "NO", label: "No" },
];

export default class BillingTemplateSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      valid: false,
      msg: "",
      toastColor: "",
      billingTemplates: [],
      template: {
        id: 0,
        billingTemplateType: "SEARCH",
        credits: 0,
        activeStatus: "YES",
      },
      editing: false,
      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchTemplates = this.fetchTemplates.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.fetchTemplates(token);
  }

  fetchTemplates(token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + "/billing/getallbillingtemplates", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const templates = Array.isArray(response.data) ? response.data : [];
        this.setState({
          billingTemplates: templates,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          billingTemplates: [],
          loading: false,
          error:
            error?.response?.data?.message ||
            "Failed to load billing templates.",
          msg:
            error?.response?.data?.message ||
            "Failed to load billing templates.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    let newValue = value;
    if (name === "credits") {
      newValue = parseInt(value) || 0;
    }
    this.setState(
      (prevState) => ({
        template: { ...prevState.template, [name]: newValue },
      }),
      this.validate
    );
  }

  handleSelect(name, selectedOption) {
    const value = selectedOption ? selectedOption.value : "";
    this.setState(
      (prevState) => ({
        template: { ...prevState.template, [name]: value },
      }),
      this.validate
    );
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (this.state.editing) {
      // Explicit validation like in registration examples
      if (
        !s.template.billingTemplateType ||
        s.template.billingTemplateType.trim() === ""
      ) {
        errors.billingTemplateType = "Type is required";
        valid = false;
      }
      if (!s.template.credits || s.template.credits <= 0) {
        errors.credits = "Credits must be greater than 0";
        valid = false;
      }
      if (!s.template.activeStatus || s.template.activeStatus.trim() === "") {
        errors.activeStatus = "Active status is required";
        valid = false;
      }
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleSave(e) {
    if (e) e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });

    const request = { ...this.state.template };

    const self = this;
    axios
      .post(API + "/billing/billingtemplatesave", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          self.setState({
            msg: "Billing template saved successfully!",
            toastColor: "success",
            loading: false,
          });
          // Reset form
          self.setState({
            template: {
              id: 0,
              billingTemplateType: "SEARCH",
              credits: 0,
              activeStatus: "YES",
            },
            editing: false,
            errors: {},
          });
          // Refetch data
          self.fetchTemplates(token);
        } else {
          self.setState({
            msg: response.data.message || "Failed to save billing template.",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to save billing template. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleEdit(template) {
    this.setState(
      {
        template: { ...template },
        editing: true,
      },
      this.validate
    );
  }

  handleCancelEdit() {
    this.setState({
      template: {
        id: 0,
        billingTemplateType: "SEARCH",
        credits: 0,
        activeStatus: "YES",
      },
      editing: false,
      errors: {},
    });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 flex-grow-1 d-flex flex-column">
          <Banner title="Billing Template Settings" />
          {divMsg}
          <div className="d-flex flex-column flex-grow-1 px-5 h-60">
            {s.editing ? (
              // Edit/Add Form
              <form
                className="d-flex flex-column align-items-center w-100 mt-2 pt-3 pb-2 h-100 overflow-auto"
                autoComplete="off"
                onSubmit={this.handleSave}
              >
                <div className="row g-3 mx-auto" style={{maxWidth: 62 + 'rem'}}>
                  <div className="input-group">
                    <label className="input-group-text">Type</label>
                    <Select
                      name="billingTemplateType"
                      value={BILLING_TEMPLATE_TYPES.find(
                        (type) => type.value === s.template.billingTemplateType
                      )}
                      onChange={(e) =>
                        this.handleSelect("billingTemplateType", e)
                      }
                      className={`form-control ${
                        s.errors.billingTemplateType ? " !border-red-500" : ""
                      }`}
                      required
                      options={BILLING_TEMPLATE_TYPES}
                    />
                    {s.errors.billingTemplateType && (
                      <span className="input-group-error">
                        {s.errors.billingTemplateType}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Credits</label>
                    <input
                      name="credits"
                      type="number"
                      min="1"
                      className={`form-control ${
                        s.errors.credits ? " !border-red-500" : ""
                      }`}
                      value={s.template.credits}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.credits && (
                      <span className="input-group-error">
                        {s.errors.credits}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Active Status</label>
                    <Select
                      name="activeStatus"
                      value={ACTIVE_STATUS_OPTIONS.find(
                        (status) => status.value === s.template.activeStatus
                      )}
                      onChange={(e) => this.handleSelect("activeStatus", e)}
                      className={`form-control ${
                        s.errors.activeStatus ? " !border-red-500" : ""
                      }`}
                      required
                      options={ACTIVE_STATUS_OPTIONS}
                    />
                    {s.errors.activeStatus && (
                      <span className="input-group-error">
                        {s.errors.activeStatus}
                      </span>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-center gap-3 mt-4">
                  {s.valid && (
                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.handleCancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            ) : (
              // Table View
              <div className="h-full w-full">
                <div className="d-flex gap-2 mb-2 align-items-baseline justify-content-between">
                  <h3 className="fw-bold">Configured Billing Templates</h3>
                  <button
                    className="hover:font-bold flex gap-1 group"
                    onClick={() => this.handleEdit({})}
                  >
                    <i
                      className="bi bi-plus-circle group-hover:scale-105"
                      style={{ color: "black" }}
                    ></i>
                    Add
                  </button>
                </div>
                {s.billingTemplates.length === 0 ? (
                  <div className="text-muted">
                    No billing templates found.
                  </div>
                ) : (
                  <div className="overflow-x-auto w-full border h-[93%] relative overflow-y-auto">
                    <table className="table table-striped table-hover rounded">
                      <thead className="table-light sticky-top">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            ID
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Type
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Credits
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="">
                        {s.billingTemplates.map((template, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {template.id}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {template.billingTemplateType}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {template.credits}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {template.activeStatus}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                              <button
                                className="btn btn-primary"
                                onClick={() => this.handleEdit(template)}
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
          
        </div>
      </div>
    );
  }
}
